export default __webpack_public_path__ + "static/huangbin1-23ccfef2257d395f5da7538b41b8bd91.jpg";